import dayjs from '../plugins/dayjs';
// eslint-disable-next-line import/prefer-default-export
export const listDisputes = {
  data: () => ({
    disputes: [],
    disputesSearchObject: {
      page: 0,
      maxPerPage: 10,
      sort: '-disputeDate',
      startDisputeDate: dayjs().subtract(1, 'month').startOf('month').format(),
      endDisputeDate: dayjs().subtract(1, 'month').endOf('month').format(),
      dynamicSearch: '',
    },
    disputesLoading: true,
    disputesListInfo: {
      totalCount: 0,
    },
  }),
  watch: {
    disputes() {
      this.disputesLoading = false;
    },
  },
  methods: {
    async listDisputes() {
      this.disputesLoading = true;
      const { data, headers, errorCode } = await this.$store.dispatch('disputes/listDisputes', { ...this.disputesSearchObject });
      if (data) {
        this.disputes = data;
      }
      if (errorCode) {
        this.disputesLoading = false;
      }
      this.disputesListInfo = this.formatHeaders(headers);
    },
    formatHeaders(headers) {
      if (!headers) return {};
      return {
        totalCount: Number(headers['x-total-count'] || 0),
      };
    },
  },
};
